export const ReportRuleInstanceFragment = `
  fragment ReportRuleInstanceFragment on ReportRuleInstance {
    id
    name
    description
    version
    specVersion
    latest
    deleted
    accountId
    type
    pollingInterval
    operations {
      actions
    }
    outputs
  }
`;

const QuestionRuleInstanceCommonFields = `
    id
    name
    description
    version
    specVersion
    latest
    pollingInterval
    templates
    deleted
    accountId
    type
    latestAlertId
    latestAlertIsActive
    outputs
    question {
      queries {
        name
        query
        version
      }
    }
    operations {
      when
      actions
    }
`;

export const QuestionRuleInstanceWithoutTagsFragment = `
  fragment QuestionRuleInstanceWithoutTagsFragment on QuestionRuleInstance {
    ${QuestionRuleInstanceCommonFields}
  }
`;

export const QuestionRuleInstanceFragment = `
  fragment QuestionRuleInstanceFragment on QuestionRuleInstance {
    ${QuestionRuleInstanceCommonFields}
    tags
  }
`;
